import { render, staticRenderFns } from "./resultados.vue?vue&type=template&id=0f3a5098&"
import script from "./resultados.vue?vue&type=script&lang=js&"
export * from "./resultados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports